import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'olap_homepage',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'olap_homepage',
        loadChildren: './views/main/main.module#MainModule'
      },
      {
        path: 'olap_sss_loans',
        loadChildren: './views/olap_sss_loans/loans-sss.module#LoansSssModule'
      },
      {
        path: 'olap_sss_review',
        loadChildren: './views/olap_sss_apply/sss-apply.module#SssApplyModule'
      },
      {
        path: 'olap_sss_apply',
        loadChildren: './views/olap_sss_apply/sss-apply.module#SssApplyModule'
      },      
      {
        path: 'olap_apply',
        loadChildren: './views/olap_apply/apply.module#ApplyModule'
      },
      {
        path: 'olap_review',
        loadChildren: './views/olap_apply/apply.module#ApplyModule'
      },
      {
        path: 'olap_loans',
        loadChildren: './views/olap_loans/loans.module#LoansModule'
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'components',
        loadChildren: './views/components/components.module#ComponentsModule'
      },
      {
        path: 'icons',
        loadChildren: './views/icons/icons.module#IconsModule'
      },
      {
        path: 'forms',
        loadChildren: './views/forms/forms.module#FormsModule'
      },
      {
        path: 'editors',
        loadChildren: './views/editors/editors.module#EditorsModule'
      },
      {
        path: 'plugins',
        loadChildren: './views/plugins/plugins.module#PluginsModule'
      },
      {
        path: 'widgets',
        loadChildren: './views/widgets/widgets.module#WidgetsModule'
      },
      {
        path: 'charts',
        loadChildren: './views/chartjs/chartjs.module#ChartJSModule'
      },
      {
        path: 'google-maps',
        loadChildren: './views/google-maps/google-maps.module#GoogleMapsModule'
      },
      {
        path: 'uikits',
        loadChildren: './views/uikits/uikits.module#UIKitsModule'
      },
      {
        path: 'admin',
        loadChildren: './views/olap_admin/admin.module#AdminModule'
      },
      {
        path: 'tools/esign',
        loadChildren: './service/tools/esign.module#EsignModule'
      },
      {
        path: 'renewals_apply',
        loadChildren: './views/olap_renewal_apply/renewals-sss.module#RenewalsSssModule'
      },
      {
        path: 'renewals_review',
        loadChildren: './views/olap_renewal_apply/renewals-sss.module#RenewalsSssModule'
      },
      {
        path: 'renewals',
        loadChildren: './views/olap_renewals/renewals.module#RenewalsModule'
      },
      {
        path: 'thirteenth_month_apply',
        loadChildren: './views/olap_thirteenthmonth_apply/thirteenth-month-apply.module#ThirteenthMonthSssApplyModule'
      },
      {
        path: 'thirteenth_month_review',
        loadChildren: './views/olap_thirteenthmonth_apply/thirteenth-month-apply.module#ThirteenthMonthSssApplyModule'
      },
      {
        path: 'thirteenth_month_loans',
        loadChildren: './views/olap_thirteenthmonth_loans/thirteenth-month-loans.module#ThirteenthMonthLoansSssModule'
      },
    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/app.routing.ts